import React from 'react';
import { IllustrationProps } from '../../../../../types/Common';
import useToggleIllustrationColors from '../../hooks/useToggleIllustrationColors';

const IllustrationInsuranceOldtimerFullCasco: React.FC<
  React.PropsWithChildren<IllustrationProps>
> = ({ isActive = true, ...otherProps }) => {
  const colors = useToggleIllustrationColors(isActive);
  return (
    <svg
      width={356}
      height={228}
      viewBox="0 0 356 228"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <mask
        id="mask0_1864_6884"
        style={{ maskType: 'alpha' }}
        width="356"
        height="228"
        x="0"
        y="0"
        maskUnits="userSpaceOnUse"
      >
        <path fill="#C0C2C9" d="M0 0h356v228H0V0z"></path>
      </mask>
      <g mask="url(#mask0_1864_6884)">
        <path
          fill={colors.primary[50]}
          d="M337 161c0 88.366-71.634 160-160 160S17 249.366 17 161 88.634 1 177 1s160 71.634 160 160z"
        ></path>
        <path
          fill="#fff"
          stroke={colors.primary[200]}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="M293.419 116.376a5.132 5.132 0 00-3.624 1.503 5.133 5.133 0 00-1.5 3.625v17.936h10.252v-17.936a5.127 5.127 0 00-5.128-5.128z"
        ></path>
        <circle
          r="33.5"
          fill={colors.primary[50]}
          stroke={colors.primary[200]}
          strokeWidth="4"
          transform="matrix(-1 0 0 1 298.003 190.5)"
        ></circle>
        <circle
          r="21.5"
          fill="#fff"
          stroke={colors.primary[200]}
          strokeWidth="4"
          transform="matrix(-1 0 0 1 298.003 190.5)"
        ></circle>
        <circle
          r="33.5"
          fill={colors.primary[50]}
          stroke={colors.primary[200]}
          strokeWidth="4"
          transform="matrix(-1 0 0 1 58.003 190.5)"
        ></circle>
        <circle
          r="21.5"
          fill="#fff"
          stroke={colors.primary[200]}
          strokeWidth="4"
          transform="matrix(-1 0 0 1 58.003 190.5)"
        ></circle>
        <path
          fill={colors.primary[50]}
          stroke={colors.primary[200]}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="M221.671 183.004H117.703a25.353 25.353 0 01-12.808-3.698 25.35 25.35 0 01-9.164-9.682 43.446 43.446 0 00-70.604-7.836 5.128 5.128 0 01-7.095.278 5.125 5.125 0 01-.561-7.078 53.697 53.697 0 0170.027-9.051 53.698 53.698 0 0117.205 18.739 14.89 14.89 0 0013 8.092h103.968c11.66 0 20.444-7.248 30.608-15.64 11.488-9.484 24.508-20.236 43.704-20.236a65.404 65.404 0 0138.8 13.72 5.123 5.123 0 01-1.98 9.26 5.126 5.126 0 01-3.836-.82 55.633 55.633 0 00-32.968-11.908c-15.512 0-26.036 8.688-37.176 17.888-10.72 8.828-21.804 17.972-37.152 17.972z"
        ></path>
        <path
          fill="#fff"
          stroke={colors.primary[200]}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="M57.671 136.876a53.809 53.809 0 0147.052 27.784 14.897 14.897 0 0013 8.092h103.948c11.66 0 20.444-7.248 30.608-15.64 9.88-8.156 20.92-17.2 36-19.6v-16h-61.204a15.659 15.659 0 01-15.656-15.656V67.5c.065-1.544-2.777-7.755-7.688-7.496h-143.5a10.248 10.248 0 00-10.248 10.244v67.256a53.494 53.494 0 017.688-.628z"
        ></path>
        <path
          stroke={colors.primary[200]}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="M103.795 121.504v15.512a13.286 13.286 0 003.284 8.736l10.688 12.22a13.263 13.263 0 004.51 3.348 13.263 13.263 0 005.49 1.184h24.716v-41h-48.688z"
        ></path>
        <path
          fill={colors.primary[100]}
          stroke={colors.primary[200]}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="M103.795 70.252H70.503a7.712 7.712 0 00-7.712 7.712v28.156a15.384 15.384 0 0015.384 15.384h25.6l.02-51.252zM103.795 70.252h48.688V121.5h-48.688V70.252zM201.171 121.504V77.96a7.706 7.706 0 00-7.708-7.708h-40.98v51.252h48.688z"
        ></path>
        <path
          stroke={colors.primary[200]}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="M152.483 121.504v41h40.996a7.69 7.69 0 007.692-7.704v-33.296h-48.688zM134.547 131.752h7.684M162.731 131.752h7.688"
        ></path>
        <g filter="url(#filter0_dd_1864_6884)">
          <circle cx="233" cy="85" r="55" fill="#fff"></circle>
          <circle
            cx="233"
            cy="85"
            r="53"
            stroke={colors.primary[500]}
            strokeWidth="4"
          ></circle>
        </g>
        <path
          fill={colors.primary[100]}
          stroke={colors.primary[500]}
          strokeLinejoin="round"
          strokeWidth="3"
          d="M270 84.985a2.367 2.367 0 00-.699-1.681 2.386 2.386 0 00-1.687-.695h-5.64l2.701-3.228a2.36 2.36 0 00.281-2.627 2.381 2.381 0 00-2.328-1.264 2.386 2.386 0 00-1.617.846l-5.25 6.273h-6.12l4.454-5.814a2.375 2.375 0 00-1.983-3.696h-8.134l3.771-5.547 8.159-.815c.613-.082 1.17-.4 1.553-.883a2.37 2.37 0 00-.332-3.287 2.391 2.391 0 00-1.698-.558l-4.2.418 3.163-4.655a2.367 2.367 0 00.367-1.783 2.377 2.377 0 00-1.863-1.88 2.395 2.395 0 00-2.455.996l-3.163 4.656-1.17-4.042a2.382 2.382 0 00-1.139-1.422 2.392 2.392 0 00-3.242.93 2.367 2.367 0 00-.204 1.809l2.274 7.85-4.284 6.304-4.355-8.66a2.479 2.479 0 00-2.134-1.209 2.49 2.49 0 00-2.133 1.208l-4.349 8.669-4.285-6.305 2.275-7.85a2.372 2.372 0 00-1.632-2.943 2.391 2.391 0 00-2.953 1.627l-1.169 4.034-3.163-4.656a2.38 2.38 0 00-1.525-1.002 2.395 2.395 0 00-1.788.366 2.375 2.375 0 00-.638 3.303l3.163 4.655-4.199-.42a2.392 2.392 0 00-1.698.558 2.376 2.376 0 00-.331 3.287c.383.483.939.8 1.552.883l8.158.815 3.771 5.546h-8.137a2.386 2.386 0 00-2.384 2.492c.021.43.159.847.398 1.205l4.454 5.813h-6.123l-5.248-6.278a2.395 2.395 0 00-3.364-.3 2.376 2.376 0 00-.301 3.353l2.703 3.232h-5.641a2.395 2.395 0 00-1.721.677 2.376 2.376 0 00-.531 2.622 2.376 2.376 0 001.323 1.29c.296.116.612.172.929.165h5.641l-2.703 3.232a2.38 2.38 0 00-.543 1.738 2.358 2.358 0 00.848 1.611 2.39 2.39 0 003.36-.303l5.248-6.278h6.123l-4.454 5.82a2.368 2.368 0 00-.118 2.441 2.385 2.385 0 002.104 1.255h8.131l-3.772 5.546-8.158.814a2.388 2.388 0 00-1.554.883 2.374 2.374 0 00.333 3.288 2.386 2.386 0 001.699.557l4.199-.419-3.163 4.655a2.378 2.378 0 00.638 3.303 2.394 2.394 0 003.313-.636l3.163-4.655 1.172 4.042a2.378 2.378 0 001.143 1.4 2.397 2.397 0 001.801.195 2.385 2.385 0 001.419-1.121 2.37 2.37 0 00.22-1.792l-2.27-7.86 4.285-6.304 4.349 8.67a2.393 2.393 0 004.267 0l4.35-8.67 4.285 6.304-2.275 7.85a2.366 2.366 0 00.187 1.825 2.381 2.381 0 002.37 1.226 2.39 2.39 0 001.605-.897c.195-.248.338-.532.421-.836l1.172-4.042 3.163 4.656a2.39 2.39 0 003.313.635 2.375 2.375 0 00.638-3.302l-3.163-4.656 4.199.419a2.385 2.385 0 002.533-2.133 2.372 2.372 0 00-.501-1.711 2.39 2.39 0 00-1.554-.884l-8.158-.817-3.772-5.546h8.139a2.392 2.392 0 002.102-1.257 2.366 2.366 0 00-.117-2.44l-4.454-5.82h6.118l5.248 6.278a2.393 2.393 0 003.36.303 2.376 2.376 0 00.304-3.349l-2.702-3.231h5.641a2.39 2.39 0 001.686-.692 2.37 2.37 0 00.702-1.677zm-22.348-7.132l-3.831 4.756h-6.3l3.229-4.755h6.902zm-14.626-8.947l3.416 6.808-3.416 5.03-3.419-5.03 3.419-6.808zm-14.624 8.947h6.902l3.229 4.756h-6.3l-3.831-4.755zm0 14.264l3.831-4.755h6.3l-3.229 4.755h-6.902zm14.624 8.947l-3.419-6.807 3.414-5.03 3.416 5.03-3.411 6.807zm14.626-8.947h-6.902l-3.229-4.755h6.3l3.831 4.755z"
        ></path>
        <path
          fill={colors.primary[500]}
          fillRule="evenodd"
          d="M20 226a2 2 0 012-2h310a2 2 0 110 4H22a2 2 0 01-2-2z"
          clipRule="evenodd"
        ></path>
      </g>
      <defs>
        <filter
          id="filter0_dd_1864_6884"
          width="142"
          height="142"
          x="162"
          y="22"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset dy="8"></feOffset>
          <feGaussianBlur stdDeviation="8"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0.376471 0 0 0 0 0.380392 0 0 0 0 0.439216 0 0 0 0.16 0"></feColorMatrix>
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1864_6884"
          ></feBlend>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset dy="2"></feOffset>
          <feGaussianBlur stdDeviation="2"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0.156863 0 0 0 0 0.160784 0 0 0 0 0.239216 0 0 0 0.04 0"></feColorMatrix>
          <feBlend
            in2="effect1_dropShadow_1864_6884"
            result="effect2_dropShadow_1864_6884"
          ></feBlend>
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_1864_6884"
            result="shape"
          ></feBlend>
        </filter>
      </defs>
    </svg>
  );
};

export default IllustrationInsuranceOldtimerFullCasco;
